import React from 'react';

const TileItem = (props) => {
    const {tile, active} = props;
    return(
        <div className={active ? "tile-item-active shadow-sm" : "tile-item shadow-sm"} onClick={props.onClick}>
            <div className="tile-count">
                {tile.count}
            </div>
            <div className="tile-title">
                {tile.title}
            </div>
        </div>
    )
}

export default TileItem;